import React, { forwardRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import DragIndicatorOutlined from "@material-ui/icons/DragIndicatorOutlined";

export const Handle = forwardRef((props, ref) => (
  <IconButton ref={ref} style={{ cursor: "grab" }} {...props} color="primary">
    <DragIndicatorOutlined />
  </IconButton>
));
